import api from '@/services/api';
import { createRouter, createWebHashHistory } from 'vue-router';
import { Capacitor } from '@capacitor/core';
import { AppLauncher } from '@capacitor/app-launcher';
import { Browser } from '@capacitor/browser';
import { hasSchoolConfig } from '@/services/schoolService';

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue')
  },
  {
    path: '/pair-school',
    name: 'SchoolPairing',
    component: () => import('@/views/auth/SchoolPairingView.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/ForgotPassword.vue')
  },
  {
    path: '/otp/:phoneNumber',
    name: 'OTPScreen',
    component: () => import('@/views/auth/OTPScreen.vue'),
    props: true
  },
  {
    path: '/change-password/:token',
    name: 'ChangePassword',
    component: () => import('@/views/auth/ChangePassword.vue'),
    props: true
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/HomeView.vue')
  },
  {
    path: '/teacher-home',
    name: 'TeacherHome',
    component: () => import('@/views/teacher/TeacherHomeView.vue')
  },
  {
    path: '/admin-home',
    name: 'AdminHome',
    component: () => import('@/views/admin/AdminHomeView.vue')
  },
  {
    path: '/admin-student-directory',
    name: 'AdminStudentDirectory',
    component: () => import('@/views/admin/AdminStudentDirectoryView.vue')
  },
  {
    path: '/admin-staff-directory',
    name: 'AdminStaffDirectory',
    component: () => import('@/views/admin/AdminStaffDirectoryView.vue')
  },
  {
    path: '/admin-ppdb',
    name: 'AdminPpdb',
    component: () => import('@/views/admin/AdminPpdbView.vue')
  },
  {
    path: '/admin-class-promotion',
    name: 'AdminClassPromotion',
    component: () => import('@/views/admin/AdminClassPromotionView.vue')
  },
  {
    path: '/admin-salary',
    name: 'AdminSalary',
    component: () => import('@/views/admin/AdminSalaryView.vue')
  },
  {
    path: '/admin-overtime',
    name: 'AdminOvertime',
    component: () => import('@/views/admin/AdminOvertimeView.vue')
  },
  {
    path: '/admin-overtime-setting',
    name: 'AdminOvertimeSetting',
    component: () => import('@/views/admin/AdminOvertimeSettingView.vue')
  },
  {
    path: '/admin-schedule',
    name: 'AdminSchedule',
    component: () => import('@/views/admin/AdminScheduleView.vue')
  },
  {
    path: '/admin-student-schedule',
    name: 'AdminStudentSchedule',
    component: () => import('@/views/admin/AdminStudentScheduleView.vue')
  },
  {
    path: '/admin-calendar',
    name: 'AdminAcademicCalendar',
    component: () => import('@/views/admin/AdminAcademicCalendarView.vue')
  },
  {
    path: '/admin-academic-year',
    name: 'AdminAcademicYear',
    component: () => import('@/views/admin/AdminAcademicYearView.vue')
  },
  {
    path: '/admin-class-management',
    name: 'AdminClassManagement',
    component: () => import('@/views/admin/AdminClassManagementView.vue')
  },
  {
    path: '/admin-subject-management',
    name: 'AdminSubjectManagement',
    component: () => import('@/views/admin/AdminSubjectManagementView.vue')
  },
  {
    path: '/admin-lms-module',
    name: 'AdminLmsModule',
    component: () => import('@/views/admin/AdminLmsModuleView.vue')
  },
  {
    path: '/admin-staff-attendance',
    name: 'AdminStaffAttendance',
    component: () => import('@/views/admin/AdminStaffAttendanceView.vue')
  },
  {
    path: '/admin-billing',
    name: 'AdminBilling',
    component: () => import('@/views/admin/AdminBillingView.vue')
  },
  {
    path: '/teacher-daily-attendance',
    name: 'TeacherDailyAttendance',
    component: () => import('@/views/teacher/TeacherDailyAttendanceView.vue')
  },
  {
    path: '/teacher-attendance',
    name: 'TeacherAttendance',
    component: () => import('@/views/teacher/TeacherAttendanceView.vue')
  },
  {
    path: '/teacher-schedule',
    name: 'TeacherSchedule',
    component: () => import('@/views/teacher/TeacherScheduleView.vue')
  },
  {
    path: '/teacher-permission-approval',
    name: 'TeacherPermissionApproval',
    component: () => import('@/views/teacher/TeacherPermissionApprovalView.vue')
  },
  {
    path: '/teacher-leaves',
    name: 'TeacherLeaves',
    component: () => import('@/views/teacher/TeacherLeaveView.vue')
  },
  {
    path: '/admin-staff-leave-approval',
    name: 'AdminStaffLeaveApproval',
    component: () => import('@/views/admin/AdminStaffLeaveApprovalView.vue')
  },
  {
    path: '/teacher-discipline',
    name: 'TeacherDiscipline',
    component: () => import('@/views/teacher/TeacherDisciplineView.vue')
  },
  {
    path: '/teacher-tahfidz',
    name: 'TeacherTahfidz',
    component: () => import('@/views/teacher/TeacherTahfidzView.vue')
  },
  {
    path: '/teacher-tugas',
    name: 'TeacherTugas',
    component: () => import('@/views/teacher/TeacherTugasView.vue')
  },
  {
    path: '/teacher-tugas/:id',
    name: 'TeacherTugasDetail',
    component: () => import('@/views/teacher/TeacherTugasDetailView.vue'),
    props: true
  },
  {
    path: '/teacher-materi',
    name: 'TeacherMateri',
    component: () => import('@/views/teacher/TeacherMateriView.vue')
  },
  {
    path: '/teacher-materi/:id',
    name: 'TeacherMateriDetail',
    component: () => import('@/views/teacher/TeacherMateriDetailView.vue'),
    props: true
  },
  {
    path: '/teacher-assessment',
    name: 'TeacherAssessment',
    component: () => import('@/views/teacher/TeacherAssessmentListView.vue')
  },
  {
    path: '/teacher-assessment/input',
    name: 'TeacherAssessmentInput',
    component: () => import('@/views/teacher/TeacherAssessmentInputView.vue')
  },
  {
    path: '/teacher-homeroom',
    name: 'TeacherHomeroom',
    component: () => import('@/views/teacher/TeacherHomeroomView.vue')
  },
  {
    path: '/teacher-reports',
    name: 'TeacherReports',
    component: () => import('@/views/teacher/TeacherReportView.vue')
  },
  {
    path: '/teacher-daily-report',
    name: 'TeacherDailyReport',
    component: () => import('@/views/teacher/TeacherDailyReportView.vue')
  },
  {
    path: '/teacher-child-daily-report',
    name: 'TeacherChildDailyReport',
    component: () => import('@/views/teacher/TeacherChildDailyReportView.vue')
  },
  {
    path: '/teacher-weekly-report',
    name: 'TeacherWeeklyReport',
    component: () => import('@/views/teacher/TeacherWeeklyReportView.vue')
  },
  {
    path: '/teacher-extracurricular',
    name: 'TeacherExtracurricular',
    component: () => import('@/views/teacher/TeacherExtracurricularView.vue')
  },
  {
    path: '/teacher-student-qr-kiosk',
    name: 'TeacherStudentQrKiosk',
    component: () => import('@/views/teacher/TeacherStudentQrKioskView.vue')
  },
  {
    path: '/teacher-student-attendance-manual',
    name: 'TeacherStudentAttendanceManual',
    component: () => import('@/views/teacher/TeacherStudentAttendanceManualView.vue')
  },
  {
    path: '/teacher-murajaah-verification',
    name: 'TeacherMurajaahVerification',
    component: () => import('@/views/teacher/TeacherMurajaahVerificationView.vue')
  },
  {
    path: '/teacher-activities',
    name: 'TeacherActivities',
    component: () => import('@/views/teacher/TeacherActivityView.vue')
  },
  {
    path: '/teacher-hris-sso',
    name: 'TeacherHrisSso',
    beforeEnter: async (to, from, next) => {
      try {
        const res = await api.get('/teacher/hris-sso-url');
        const targetUrl = res.data?.data?.url;

        if (targetUrl) {
          if (Capacitor.isNativePlatform()) {
            await Browser.open({ url: targetUrl });
          } else {
            window.open(targetUrl, '_blank');
          }
        }
      } catch (err) {
        console.error('Gagal membuka SSO Portal HRIS:', err);
      }
      next(false);
    }
  },
  {
    path: '/teacher-siakad-sso',
    name: 'TeacherSiakadSso',
    beforeEnter: async (to, from, next) => {
      try {
        const res = await api.get('/teacher/siakad-sso-url');
        const targetUrl = res.data?.data?.url;

        if (targetUrl) {
          if (Capacitor.isNativePlatform()) {
            await Browser.open({ url: targetUrl });
          } else {
            window.open(targetUrl, '_blank');
          }
        }
      } catch (err) {
        console.error('Gagal membuka SSO Web SIAKAD:', err);
      }
      next(false);
    }
  },
  {
    path: '/publication',
    children: [
      {
        path: '',
        name: 'Publication',
        component: () => import('@/views/publication/PublicationView.vue')
      },
      {
        path: 'detail/:id',
        name: 'PublicationDetail',
        component: () => import('@/views/publication/PublicationDetail.vue')
      }
    ]
  },
  {
    path: '/academic',
    children: [
      {
        path: '',
        name: 'Academic',
        component: () => import('@/views/academic/Academic.vue')
      },
      {
        path: 'rapor',
        name: 'AcademicRapor',
        component: () => import('@/views/academic/RaporPage.vue')
      },
      {
        path: 'study-material',
        name: 'AcademicStudyMaterial',
        component: () => import('@/views/academic/StudyMaterial.vue')
      },
      {
        path: 'course',
        children: [
          {
            path: '',
            name: 'AcademicCourse',
            component: () => import('@/views/academic/Course.vue')
          },
          {
            path: 'test/:course_id',
            name: 'TestCourse',
            component: () => import('@/views/academic/Test.vue')
          },
          {
            path: 'penilaian/:course_id',
            name: 'PenilaianTest',
            component: () => import('@/views/academic/PenilaianTest.vue')
          }
        ]
      },
      {
        path: 'history',
        name: 'AcademicHistory',
        component: () => import('@/views/academic/History.vue')
      },
      {
        path: '/weekly-competency/:subject_id',
        name: 'WeeklyCompetency',
        component: () => import('@/views/academic/WeeklyCompetency.vue')
      },
      {
        path: 'subject-attendance',
        children: [
          {
            path: '',
            name: 'SubjectAttendance',
            component: () => import('@/views/academic/SubjectAttendance.vue')
          },
          {
            path: 'detail/:id',
            name: 'SubjectAttendanceDetail',
            component: () => import('@/views/academic/SubjectAttendanceDetail.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/notification',
    name: 'Notification',
    component: () => import('@/views/notification/NotificationView.vue')
  },
  {
    path: '/absensi',
    name: 'Absensi',
    component: () => import('@/views/home/absensi/AbsensiView.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/home/profile/Profile.vue')
  },
  {
    path: '/absensi-all',
    name: 'AbsensiAll',
    component: () => import('@/views/home/absensi/AbsensiAll.vue')
  },
  {
    path: '/absen-mapel-all',
    name: 'AbsenMapelAll',
    component: () => import('@/views/home/absensi/AbsenMapelAll.vue')
  },
  {
    path: '/academic-report',
    children: [
      {
        path: '',
        name: 'AcademicReport',
        component: () => import('@/views/home/academic_report/AcademicReport.vue')
      },
      {
        path: 'all',
        name: 'AcademicReportAll',
        component: () => import('@/views/home/academic_report/AcademicReportAll.vue')
      }
    ]
  },
  {
    path: '/top-up',
    name: 'TopUp',
    component: () => import('@/views/home/TopUp.vue')
  },
  {
    path: '/atur-limit',
    name: 'AturLimit',
    component: () => import('@/views/home/AturLimit.vue')
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/home/HistoryView.vue')
  },
  {
    path: '/scan-qr-code',
    name: 'QRCodeScanner',
    component: () => import('@/views/QRCodeScanner.vue')
  },
  {
    path: '/bayar',
    name: 'Bayar',
    component: () => import('@/views/home/Bayar.vue')
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import('@/views/home/schedule/ScheduleView.vue')
  },
  {
    path: '/edit-profile',
    name: 'EditProfile',
    component: () => import('@/views/home/profile/EditProfile.vue')
  },
  {
    path: '/change-password-users',
    name: 'ChangePassword2',
    component: () => import('@/views/home/profile/ChangePassword.vue')
  },
  {
    path: '/close',
    name: 'CloseSelf',
    component: () => import('@/views/CloseSelf.vue')
  },
  {
    path: '/extracurricular',
    name: 'Extracurricular',
    component: () => import('@/views/home/ExtracurricularView.vue')
  },
  {
    path: '/spp-payment',
    redirect: { name: 'OtherPayment' }
  },
  {
    path: '/other-payment',
    name: 'OtherPayment',
    component: () => import('@/views/home/OtherPayment.vue')
  },
  {
    path: '/quick-access',
    children: [
      {
        path: 'absensi',
        name: 'QAIzin',
        component: () => import('@/views/home/quick_access/QAIzin.vue')
      },
      {
        path: 'course',
        name: 'QACourse',
        component: () => import('@/views/home/quick_access/QACourse.vue')
      },
      {
        path: 'tugas',
        name: 'QATugas',
        component: () => import('@/views/home/quick_access/QATugas.vue')
      },
      {
        path: 'sentiment-analytics',
        name: 'SentimentAnalytics',
        component: () => import('@/views/home/quick_access/SentimentAnalytics.vue')
      },
      {
        path: 'ujian',
        name: 'QAUjian',
        beforeEnter: async (to, from, next) => {
          try {
            const res = await api.post('/sso-login-cbt');
            const targetUrl = res.data?.data;

            if (Capacitor.isNativePlatform()) {
              const cbtPackage = 'com.example.cbt_exam';
              try {
                const { value: isInstalled } = await AppLauncher.canOpenUrl({ url: cbtPackage });
                if (isInstalled) {
                  await AppLauncher.openUrl({ url: cbtPackage });
                  next(false);
                  return;
                }
              } catch (appErr) {
                console.error(appErr);
              }

              // Fallback jika aplikasi CBT tidak ada: buka via browser Capacitor
              if (targetUrl) {
                await Browser.open({ url: targetUrl });
              }
            } else {
              // Jika diakses melalui web browser biasa (PWA / desktop)
              if (targetUrl) {
                window.open(targetUrl, '_blank');
              }
            }

            next(false);
          } catch (e) {
            console.error(e);
            next(false);
          }
        }
      },
      {
        path: 'konseling',
        name: 'QAKonseling',
        component: () => import('@/views/home/quick_access/QABimbinganKonseling.vue')
      },
      {
        path: 'kedisiplinan',
        name: 'QAKedisiplinan',
        component: () => import('@/views/home/quick_access/QABimbinganKonseling.vue')
      },
      {
        path: 'kantin',
        name: 'QAKantin',
        component: () => import('@/views/home/quick_access/QAKantin.vue')
      },
      {
        path: 'ppdb',
        name: 'QAPpdb',
        component: () => import('@/views/home/quick_access/QAPpdb.vue')
      },
      {
        path: 'chat',
        name: 'QAChat',
        component: () => import('@/views/home/quick_access/QAChat.vue')
      },
      {
        path: 'group-chat/:roomId',
        name: 'GroupChatRoom',
        component: () => import('@/views/home/quick_access/GroupChatRoom.vue')
      },
      {
        path: 'academic-calendar',
        name: 'AcademicCalendar',
        component: () => import('@/views/academic/AcademicCalendar.vue')
      }
    ]
  },
  {
    path: '/extracurricular/:id',
    name: 'ExtracurricularDetail',
    component: () => import('@/views/home/ExtracurricularDetail.vue')
  },
  {
    path: '/student-learning-report',
    name: 'StudentLearningReport',
    component: () => import('@/views/academic/StudentLearningReport.vue')
  },
  {
    path: '/student-tahfidz',
    name: 'StudentTahfidz',
    component: () => import('@/views/academic/StudentTahfidz.vue')
  },
  {
    path: '/sso-login',
    name: 'SSOLogin',
    beforeEnter: (to, from, next) => {
      const token = to.query.token;
      import('@/services/api').then(({ default: api }) => {
        api.post('/sso-login', { token }).then(res => {
          localStorage.setItem('token', res.data.data.accessToken);
          localStorage.setItem('user', JSON.stringify(res.data.data.user));
          import('@/services/deviceService').then(({ registerUserDevice }) => {
            registerUserDevice().catch(err => console.warn('SSOLogin register device error:', err));
          });
          import('@/store').then(({ default: store }) => {
            store.dispatch('user/fetchProfile');
            store.commit('children/SET_CHILDREN', []);
            store.commit('children/SET_SELECTED_CHILD', null);
            store.commit('children/SET_CHILD_SCHEDULE', null);
            const user = res.data?.data?.user;
            if (!isMobileRoleAllowed(user)) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              next({ name: 'Login' });
              return;
            }
            const isAdmin = user?.roles?.some(r => r.name === RoleEnum.ADMIN || r.name === 'admin' || r.name === 'Admin' || r.name === 'administrator' || r.name?.toLowerCase().includes('admin'));
            const isTeacher = user?.roles?.some(r => r.name === RoleEnum.TEACHER || r.name === 'teacher' || r.name === 'Teacher' || r.name === 'Guru');
            next({ name: isAdmin ? 'AdminHome' : (isTeacher ? 'TeacherHome' : 'Home') });
          });
        }).catch(() => {
          next({ name: 'Login' });
        });
      });
    }
  },
  {
    path: '/academic-achievement',
    name: 'AcademicAchievement',
    component: () => import('@/views/academic/AchievementView.vue')
  },
  {
    path: '/survey',
    name: 'QASurvey',
    component: () => import('@/views/home/quick_access/QASurvey.vue')
  },
  {
    path: '/survey-detail/:id',
    name: 'SurveyDetail',
    component: () => import('@/views/home/quick_access/SurveyDetail.vue')
  },
  {
    path: '/mass-payment-history',
    name: 'MassPaymentHistory',
    component: () => import('@/views/home/MassPaymentHistory.vue')
  },
  {
    path: '/payment-processing',
    name: 'PaymentProcessing',
    component: () => import('@/views/home/PaymentProcessing.vue')
  },
  {
    path: '/daily-report',
    name: 'DailyReport',
    component: () => import('@/views/home/quick_access/DailyReport.vue')
  },
  {
    path: '/daily-material',
    name: 'DailyMaterial',
    component: () => import('@/views/home/quick_access/DailyMaterialView.vue')
  },
  {
    path: '/weekly-report',
    name: 'WeeklyReport',
    component: () => import('@/views/academic/WeeklyReport.vue')
  },
  {
    path: '/daily-summary',
    alias: ['/summary-class', '/class-summary'],
    name: 'DailySummary',
    component: () => import('@/views/home/quick_access/DailySummary.vue')
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

import { useConfigStore } from '@/stores/useConfigStore';
import { RoleEnum, isMobileRoleAllowed, hasPermission } from '@/enums/RoleEnum';

const routeModuleMap = {
  StudentTahfidz: ['mobile_tahfidz', 'tahfidz.index', 'tahfidz_keagamaan'],
  QAIzin: ['mobile_permission', 'student_attendance.permissionrequest', 'student_attendance_group'],
  QATugas: ['mobile_homework', 'learning-modules-homeworks.index', 'learning_modules_group'],
  QAUjian: ['mobile_cbt', 'sso-login-cbt', 'cbt_group'],
  QAKonseling: ['mobile_counseling', 'student_dicipline.point_history', 'student_dicipline.violation', 'student_dicipline_group'],
  QASurvey: ['mobile_survey', 'survey-form.index', 'survey-submission.index', 'survey_group'],
  SurveyDetail: ['mobile_survey', 'survey-form.index', 'survey-submission.index', 'survey_group'],
  Extracurricular: ['mobile_extracurricular', 'student-group.index'],
  DailyReport: ['mobile_daily_report', 'daily-report.index', 'reports_group'],
  DailyMaterial: ['mobile_daily_material', 'mobile_daily_report', 'daily-report.index', 'reports_group'],
  AcademicStudyMaterial: ['mobile_study_material', 'mobile_daily_report', 'learning_modules_group'],
  WeeklyReport: ['mobile_weekly_report', 'weekly-report.index', 'reports_group'],
  DailySummary: ['mobile_daily_summary', 'daily_summary', 'mobile_daily_report', 'daily-report.index', 'reports_group'],
  AcademicAchievement: ['mobile_achievement', 'student-achievements.index'],
  OtherPayment: ['mobile_billing', 'bills.index', 'finance_group', 'finance'],
  TopUp: ['mobile_wallet', 'wallet'],
  AturLimit: ['mobile_wallet', 'wallet'],
  QARequestPickup: ['mobile_pickup', 'pickup'],
  QAChat: ['mobile_chat', 'lms-chat.index'],
  GroupChatRoom: ['mobile_chat', 'lms-chat.index'],
  Absensi: ['mobile_attendance', 'student_attendance_group'],
  TeacherSchedule: ['lms-jadwal-mengajar.my-schedule', 'lms-jadwal-mengajar.index', 'subject_management_group', 'mobile_schedule'],
  TeacherDailyAttendance: ['staff_attendance'],
  TeacherAttendance: ['lms-subject-meeting', 'lms-subject-meeting.recap-attendance'],
  TeacherPermissionApproval: ['student_attendance.permissionrequest', 'student_attendance_group', 'mobile_permission'],
  TeacherLeaves: ['staff-leave-request.index', 'staff_attendance'],
  AdminStaffLeaveApproval: ['staff-leave-request.index', 'staff-leave-request.approval', 'staff_attendance'],
  TeacherDiscipline: ['student_dicipline', 'student_dicipline.violation', 'student_dicipline.point_history', 'mobile_counseling'],
  TeacherTahfidz: ['tahfidz.index', 'tahfidz_keagamaan', 'mobile_tahfidz'],
  TeacherMurajaahVerification: ['tahfidz.murajaah.index', 'tahfidz.index', 'tahfidz_keagamaan', 'mobile_tahfidz'],
  TeacherTugas: ['lms-tugas.index', 'lms_materi_tugas_group', 'mobile_homework'],
  TeacherTugasDetail: ['lms-tugas.index', 'lms_materi_tugas_group', 'mobile_homework'],
  TeacherMateri: ['lms-materi.index', 'lms_materi_tugas_group', 'mobile_study_material', 'mobile_daily_material'],
  TeacherMateriDetail: ['lms-materi.index', 'lms_materi_tugas_group', 'mobile_study_material', 'mobile_daily_material'],
  TeacherAssessment: ['examination_group', 'exam-types.index', 'exam-marks.index', 'lms-grading-scale.index', 'mobile_report_card'],
  TeacherAssessmentInput: ['examination_group', 'exam-types.index', 'exam-marks.index', 'lms-grading-scale.index', 'mobile_report_card'],
  TeacherHomeroom: ['reports_group', 'daily-reports.homeroom'],
  TeacherReports: ['reports_group'],
  TeacherDailyReport: ['daily-report.index', 'reports_group', 'mobile_daily_report'],
  TeacherChildDailyReport: ['child-daily-reports.index', 'reports_group'],
  TeacherWeeklyReport: ['weekly-reports.index', 'weekly-report.index', 'reports_group', 'mobile_weekly_report'],
  TeacherActivities: ['school-activities.index'],
  TeacherExtracurricular: ['student-group.index', 'extracurricular_attendance', 'mobile_extracurricular'],
  TeacherStudentQrKiosk: ['student_attendance.qr_kiosk', 'student_attendance_group'],
  TeacherStudentAttendanceManual: ['student_attendance.record', 'student_attendance_group', 'mobile_attendance'],
  TeacherHrisSso: ['hris-sso'],
  TeacherSiakadSso: ['portal_siakad'],

  // Admin Module Slugs
  AdminStaffAttendance: ['staff_attendance', 'lms_teacher_daily_journal'],
  AdminBilling: ['finance_group', 'bills.index', 'bill-invoices.index'],
  AdminSalary: ['salary.index', 'salary_management'],
  AdminOvertime: ['staff_overtime', 'staff_attendance'],
  AdminOvertimeSetting: ['overtime-setting.index', 'staff_overtime'],
  AdminSchedule: ['staff_attendance', 'staff_attendance.schedule'],
  AdminStudentSchedule: ['student_attendance.schedule', 'student_attendance_group'],
  AdminStaffDirectory: ['staffs.index'],
  AdminStudentDirectory: ['students.index', 'student_data_group'],
  AdminPpdb: ['ppdb_group', 'ppdb-form.index', 'student_management'],
  AdminClassPromotion: ['grade_promotion', 'grade-promotion.index', 'student_management'],
  AdminAcademicYear: ['academic-years.index', 'academic_year_group'],
  AdminClassManagement: ['class_management_group', 'sm-class.index', 'sm-section.index', 'sm-class-room.index', 'sm-class-section.index'],
  AdminSubjectManagement: ['subject_management_group', 'sm-subject.index', 'sm-subject-group.index', 'lms-jadwal-mengajar.index'],
  AdminLmsModule: ['learning-modules.index', 'learning_modules_group'],
  AdminAcademicCalendar: ['academic-calendar.index', 'staff-academic-calendar.index', 'mobile_calendar'],
};

const routePermissionMap = {
  // Admin Routes
  AdminStaffAttendance: ['staff_attendance.history', 'staff_attendance.record', 'lms-teacher-daily-journal.index'],
  AdminBilling: ['bills.index', 'bill-invoices.index', 'bill-types.index', 'finance_group'],
  AdminSalary: ['salary.index', 'salary.create'],
  AdminOvertime: ['staff_overtime.index', 'staff_overtime.approval'],
  AdminOvertimeSetting: ['overtime-setting.index', 'staff_overtime.index'],
  AdminSchedule: ['staff_attendance.schedule'],
  AdminStudentSchedule: ['student_attendance.schedule'],
  AdminStaffDirectory: ['staffs.index', 'staffs.view'],
  AdminStudentDirectory: ['students.index', 'students.view'],
  AdminPpdb: ['ppdb-form.index', 'ppdb-form-submission.index', 'ppdb-form-payment.index'],
  AdminClassPromotion: ['grade-promotion.class-transfer', 'grade-promotion.mutation', 'grade-promotion.index'],
  AdminAcademicYear: ['academic-years.index'],
  AdminClassManagement: ['sm-class.index', 'sm-section.index', 'sm-class-room.index', 'sm-class-section.index', 'teacher-class.index'],
  AdminSubjectManagement: ['master.subject', 'master.subjectGroup', 'lms-jadwal-mengajar.index', 'mapping.subjectSelection'],
  AdminLmsModule: ['learning-modules.index', 'learning-modules-homeworks.index', 'learning-modules-scores.index', 'learning-module-libraries.index'],
  AdminAcademicCalendar: ['academic-calendar.index', 'staff-academic-calendar.index'],
  AdminStaffLeaveApproval: ['staff-leave-request.approval', 'staff-leave-request.index'],

  // Teacher Routes
  TeacherSchedule: ['class-routine.index', 'lms-jadwal-mengajar.my-schedule', 'lms-jadwal-mengajar.index'],
  TeacherDailyAttendance: ['staff_attendance.history', 'staff_attendance.record'],
  TeacherLeaves: ['staff-leave-request.index', 'staff-leave-request.approval'],
  TeacherAttendance: ['lms-subject-meeting', 'lms-subject-meeting.recap-attendance'],
  TeacherPermissionApproval: ['student_attendance.permissionRequest', 'student_attendance.permissionrequest'],
  TeacherDiscipline: ['student_dicipline.input', 'student_dicipline.point_history', 'student_dicipline'],
  TeacherTahfidz: ['tahfidz.index', 'tahfidz_keagamaan'],
  TeacherMurajaahVerification: ['tahfidz.murajaah.index', 'tahfidz.index'],
  TeacherTugas: ['lms-tugas.index', 'lms_materi_tugas_group'],
  TeacherTugasDetail: ['lms-tugas.index', 'lms_materi_tugas_group'],
  TeacherMateri: ['lms-materi.index', 'lms_materi_tugas_group'],
  TeacherMateriDetail: ['lms-materi.index', 'lms_materi_tugas_group'],
  TeacherAssessment: ['exam-marks.index', 'exam-types.index', 'examination_group'],
  TeacherAssessmentInput: ['exam-marks.index', 'exam-types.index', 'examination_group'],
  TeacherHomeroom: ['daily-reports.homeroom', 'reports_group'],
  TeacherDailyReport: ['daily-report.index', 'reports_group'],
  TeacherChildDailyReport: ['child-daily-reports.index', 'reports_group'],
  TeacherWeeklyReport: ['weekly-reports.index', 'weekly-report.index', 'reports_group'],
  TeacherActivities: ['school-activities.index'],
  TeacherExtracurricular: ['student-group.index'],
  TeacherStudentQrKiosk: ['student_attendance.qr_kiosk', 'student_attendance.record'],
  TeacherStudentAttendanceManual: ['student_attendance.record', 'student_attendance.history'],
  TeacherHrisSso: ['hris-sso'],
  TeacherSiakadSso: ['dashboard', 'portal_siakad'],
};

router.beforeEach((to, from, next) => {
  // Jika di platform web (bukan native), bypass sepenuhnya halaman scan QR sekolah
  if (!Capacitor.isNativePlatform()) {
    if (to.name === 'SchoolPairing') {
      next({ name: 'Login' });
      return;
    }
  } else {
    // Khusus mobile native: wajib scan QR sekolah jika belum ada konfigurasi
    const isSchoolConfigured = hasSchoolConfig();
    if (!isSchoolConfigured && !['SchoolPairing', 'CloseSelf'].includes(to.name)) {
      next({ name: 'SchoolPairing' });
      return;
    }
  }

  const token = localStorage.getItem('token');
  const publicRoutes = ['Login', 'SchoolPairing', 'ForgotPassword', 'OTPScreen', 'ChangePassword', 'SSOLogin', 'CloseSelf'];

  // 1. Jika belum login (tidak ada token)
  if (!token) {
    if (publicRoutes.includes(to.name)) {
      next(); // Izinkan akses rute publik (Login, dll)
    } else {
      next({ name: 'Login' }); // Redirect ke Login jika mencoba akses private route
    }
    return;
  }

  // 2. Jika sudah ada token: cek apakah role diizinkan masuk mobile
  const user = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
  })();
  if (user && Object.keys(user).length > 0 && !isMobileRoleAllowed(user)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    next({ name: 'Login' });
    return;
  }

  // 3. Jika sudah login dan mencoba buka halaman guest (Login, ForgotPassword, dll)
  if (['Login', 'ForgotPassword', 'ChangePassword'].includes(to.name)) {
    const isAdmin = (() => {
      try {
        if (user?.roles?.some(r => r.name === RoleEnum.ADMIN || r.name === 'admin' || r.name === 'Admin' || r.name === 'administrator')) return true;
        if (user?.role === 'admin' || user?.role_name === 'admin' || user?.role === 'administrator') return true;
        const piniaState = JSON.parse(localStorage.getItem('profile') || '{}');
        if (piniaState?.profile?.roles?.some(r => r.name === RoleEnum.ADMIN || r.name === 'admin' || r.name === 'Admin' || r.name === 'administrator')) return true;
      } catch (err) {
        console.warn('Gagal membaca role admin:', err);
      }
      return false;
    })();
    const isTeacher = (() => {
      try {
        if (user?.roles?.some(r => r.name === RoleEnum.TEACHER || r.name === 'teacher' || r.name === 'Teacher' || r.name === 'Guru')) return true;
        if (user?.role === 'teacher' || user?.role_name === 'teacher') return true;
        const piniaState = JSON.parse(localStorage.getItem('profile') || '{}');
        if (piniaState?.profile?.roles?.some(r => r.name === RoleEnum.TEACHER || r.name === 'teacher' || r.name === 'Teacher' || r.name === 'Guru')) return true;
      } catch (err) {
        console.warn('Gagal membaca role guru:', err);
      }
      return false;
    })();
    next({ name: isAdmin ? 'AdminHome' : (isTeacher ? 'TeacherHome' : 'Home') });
    return;
  }

  // 4. Role routing checks
  try {
    const piniaState = JSON.parse(localStorage.getItem('profile') || '{}');
    const roleId = Number(user?.role_id);
    const roleName = String(user?.role?.name || user?.role || '').toLowerCase();
    const isAdmin = roleId === 1
      || roleName.includes('admin')
      || roleName.includes('super')
      || user?.roles?.some(r => r.name === RoleEnum.ADMIN || r.name === 'admin' || r.name === 'Admin' || r.name === 'administrator' || r.name?.toLowerCase().includes('admin'))
      || piniaState?.profile?.roles?.some(r => r.name === RoleEnum.ADMIN || r.name === 'admin' || r.name === 'Admin' || r.name === 'administrator' || r.name?.toLowerCase().includes('admin'));

    const isTeacher = user?.roles?.some(r => r.name === RoleEnum.TEACHER || r.name === 'teacher' || r.name === 'Teacher' || r.name === 'Guru')
      || user?.role === 'teacher'
      || user?.role_name === 'teacher'
      || piniaState?.profile?.roles?.some(r => r.name === RoleEnum.TEACHER || r.name === 'teacher' || r.name === 'Teacher' || r.name === 'Guru');

    if (isAdmin && to.name === 'Home') {
      next({ name: 'AdminHome' });
      return;
    }
    if (isTeacher && to.name === 'Home') {
      next({ name: 'TeacherHome' });
      return;
    }
    if ((isAdmin || isTeacher) && (to.name === 'Schedule' || to.path === '/schedule')) {
      next({ name: 'TeacherSchedule' });
      return;
    }
    if (!isAdmin && to.name === 'AdminHome') {
      next({ name: isTeacher ? 'TeacherHome' : 'Home' });
      return;
    }
    if (!isTeacher && !isAdmin && ['TeacherHome', 'AdminHome', 'AdminSalary', 'AdminOvertime', 'AdminOvertimeSetting', 'AdminSchedule', 'AdminStudentSchedule', 'AdminAcademicCalendar', 'AdminAcademicYear', 'AdminClassManagement', 'AdminSubjectManagement', 'AdminLmsModule', 'AdminStaffAttendance', 'AdminBilling', 'AdminStaffLeaveApproval', 'AdminStudentDirectory', 'AdminStaffDirectory', 'AdminPpdb', 'AdminClassPromotion', 'TeacherDailyAttendance', 'TeacherAttendance', 'TeacherPermissionApproval', 'TeacherLeaves', 'TeacherDiscipline', 'TeacherTahfidz', 'TeacherTugas', 'TeacherTugasDetail', 'TeacherMateri', 'TeacherMateriDetail', 'TeacherSchedule', 'TeacherAssessment', 'TeacherAssessmentInput', 'TeacherHomeroom', 'TeacherReports', 'TeacherDailyReport', 'TeacherChildDailyReport', 'TeacherWeeklyReport', 'TeacherExtracurricular', 'TeacherStudentQrKiosk', 'TeacherStudentAttendanceManual', 'TeacherMurajaahVerification', 'TeacherActivities', 'TeacherHrisSso', 'TeacherSiakadSso'].includes(to.name)) {
      next({ name: 'Home' });
      return;
    }
  } catch (e) {
    console.error(e);
  }

  if (to.name === 'QAUjian') {
    try {
      const isParent = user?.roles?.some(r => r.name === RoleEnum.PARENTS);
      if (isParent) {
        next({ name: 'Home' });
        return;
      }
    } catch (e) {
      console.error(e);
    }
  }

  const configStore = useConfigStore();
  const requiredSlugs = routeModuleMap[to.name];
  const isTeacherRoute = typeof to.name === 'string' && to.name.startsWith('Teacher');
  const isAdminRoute = typeof to.name === 'string' && to.name.startsWith('Admin');
  const userRoleAdmin = user?.roles?.some(r => r.name === RoleEnum.ADMIN || r.name === 'admin' || r.name === 'Admin' || r.name === 'administrator');

  // 1. Cek status modul aktif sekolah
  if (requiredSlugs && configStore.isDisabled(requiredSlugs)) {
    next({ name: (isTeacherRoute || isAdminRoute) ? (userRoleAdmin ? 'AdminHome' : 'TeacherHome') : 'Home' });
    return;
  }

  // 2. Cek permission spesifik user (Spatie Siakad)
  const requiredPermissions = routePermissionMap[to.name];
  if (requiredPermissions && !hasPermission(requiredPermissions, user)) {
    next({ name: (isTeacherRoute || isAdminRoute) ? (userRoleAdmin ? 'AdminHome' : 'TeacherHome') : 'Home' });
    return;
  }

  next(); // Allow navigation
});

export default router;
